import script from "./CellEditMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CellEditMenu.vue?vue&type=script&setup=true&lang=ts"

import "./CellEditMenu.vue?vue&type=style&index=0&id=dd2056f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd2056f0"]])

export default __exports__